<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12  mt-2 py-0">
					<h4 class="m-0 p-0 text-secondary d-inline">Data Bank</h4>
					<button class="float-right btn btn-primary shadow mt-2"
					        v-on:click="formRekeningBankActive=!formRekeningBankActive">Tambah Data Bank Baru
					</button>
				</div>
				<transition name="fade">
					<div class="col-12  my-2 py-0" v-if="formRekeningBankActive">
						<div class="row p-3 mx-2 bg-white shadow">
							<div class="col-12 mb-3">
								<h4 class="my-0 py-0">Form Data Bank Baru</h4>
								<hr>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Nama Pemilik Bank <span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded" v-model="newRekeningBank.nama"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Nama Bank <span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newRekeningBank.nama_bank"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Nomor Rekening <span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newRekeningBank.no_rekening"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Cabang <span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded" v-model="newRekeningBank.cabang"/>
							</div>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="newRekeningBankSaved">
									<div class="alert alert-success" role="alert">
										Berhasil Menyimpan Data Bank Baru.
									</div>
								</div>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorNewRekeningBank">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1">{{ createErrorMessage }}</p>
										</div>
										<div v-for="err in errorRekeningBankList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1 w-100">
												{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start"
								     v-if="savingNewRekeningBank">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-primary float-right" type="button"
								        v-on:click="saveNewRekeningBank">Submit
								</button>
							</div>
						</div>
					</div>
				</transition>

				<div class="col-12  my-2 py-0">
					<datatable :currentIdx="currentPage" :datas="rekeningbanks" :structure="rekeningbankTableStructure"
					           :init="loadData"
					           :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}"
					           use-seeker seeker-url="/api/master/seeker/bank"
					           @refetch="(row)=>{rowLimit=row;getRekeningBanks()}"
					           @searching="(val)=>!val.status?getRekeningBanks():rekeningbanks=val.data"
					           @change-url="(url)=>getRekeningBanks(url+(url.includes('?')?'&':'?')+'limit='+rowLimit)">
						<template #customcell={obj,index}>
							<td v-if="isMobile" class="py-3">
								<ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Bank:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.nama_bank }}</b>
										</div>
										<hr class="my-2">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Pemilik bank:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.nama }}</b>
										</div>
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">No Rekening:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.no_rekening }}</b>
										</div>
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Cabang:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.cabang }}</b>
										</div>
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Status:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.status_bank }}</b>
										</div>
										<hr class="my-2">
									</li>
									<li>
										<div class="text-left mx-3 mt-2 pt-0">
											<b-button v-b-modal.modal-edit-bank class="btn btn-info mr-2"
											          v-on:click="selectedBank=index;dataEdit=Object.assign({},obj)">
												<b-icon icon="pencil-square"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-delete
											          v-on:click="deleteId=obj.id;itemToDelete=obj"
											          class="btn btn-danger">
												<b-icon icon="trash"></b-icon>
											</b-button>
										</div>
									</li>
								</ul>
							</td>
							<td v-if="!isMobile">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
							<td v-if="!isMobile">{{ obj.nama }}</td>
							<td v-if="!isMobile">{{ obj.nama_bank }}</td>
							<td v-if="!isMobile">{{ obj.no_rekening }}</td>
							<td v-if="!isMobile">{{ obj.cabang }}</td>
							<td v-if="!isMobile"><span class="badge badge-info">{{ obj.status_bank }}</span></td>
							<td v-if="!isMobile">
								<b-button v-b-modal.modal-edit-bank class="btn btn-info mb-1 mr-2"
								          v-on:click="selectedBank=index;dataEdit=Object.assign({},obj)">
									<b-icon icon="pencil-square"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj"
								          class="btn btn-danger mb-1 mr-2">
									<b-icon icon="trash"></b-icon>
								</b-button>
							</td>
						</template>
					</datatable>
				</div>
				<b-modal no-close-on-esc content-class="m-0" id="modal-edit-bank" title="Edit Rekening Bank" scrollable
				         no-close-on-backdrop size="lg" @hide="editModalClose">
					<b-container fluid v-if="!loadData&&rekeningbanks.length>0">
						<b-row class="mt-3 pt-1" v-if="rekeningbanks[selectedBank]!=undefined">
							<b-col cols="12" class="my-1">
							</b-col>
							<b-col cols="12" md="6" lg="4">
								<label class="d-block">Nama Pemilik Bank</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="rekeningbanks[selectedBank].nama"/>
							</b-col>
							<b-col cols="12" md="6" lg="4">
								<label class="d-block">Nama Bank</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="rekeningbanks[selectedBank].nama_bank"/>
							</b-col>
							<b-col cols="12" md="6" lg="4">
								<label class="d-block">Nomor Rekening</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="rekeningbanks[selectedBank].no_rekening"/>
							</b-col>
							<b-col cols="12" md="6" lg="4">
								<label class="d-block">Cabang</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="rekeningbanks[selectedBank].cabang"/>
							</b-col>
							<b-col cols="12" md="6" lg="4">
								<label class="d-block">Status</label>
								<select class="custom-select" v-model="rekeningbanks[selectedBank].status_bank">
									<option value="active">Active</option>
									<option value="non-active">Non-Active</option>
								</select>
							</b-col>

							<b-col cols="12" class="my-3 text-right" v-if="updateClientState">
								<div class="d-flex align-items-center justify-content-start">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
							</b-col>
							<div class="col-12 mt-3" v-if="updateClientSaved">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-success" role="alert">
										Berhasil update data klien.
									</div>
								</div>
							</div>
							<div class="col-12 mt-3" v-if="errorClientSaved">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-danger" role="alert">
										Gagal update data klien.
									</div>
								</div>
							</div>
							<b-col cols="12" class="my-3 text-right">
								<button class="btn btn-info" v-on:click="updateClientData">Simpan</button>
							</b-col>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<b-button class="btn btn-secondary mr-2"
							          @click="(!updateUserState&&!updateClientState)?$bvModal.hide('modal-edit-bank'):''">
								Tutup
							</b-button>
							<!-- <button class="btn btn-info" v-on:click="updateClientData">submit</button> -->
						</div>
					</template>
				</b-modal>
				<modal-delete url="/api/master/bank/" @read="()=>{console.log('modal ready')}" @result="deleteResult"
				              :targetid="deleteId">
					Yakin mau menghapus data dengan detail berikut :<br>
					<ul>
						<li>Nama: {{ itemToDelete.nama }}</li>
					</ul>
				</modal-delete>


			</div>
		</div>
	</div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
import * as axios from "axios";
import Datatable from "../../components/Datatable.vue";
import SmartSelect from "../../components/SmartSelect.vue";
import ModalDelete from "../../components/ModalDelete.vue";

export default {
	components: {
		//   LTable,
		//   ChartCard,
		//   StatsCard
		"datatable": Datatable,
		"smart-select": SmartSelect,
		"modal-delete": ModalDelete
	},
	data() {
		return {
			currentPage: 1,
			perPage: null,
			rowLimit: 10,
			nextUrl: null,
			prevUrl: null,
			isMobile: false,
			//step 1 edit
			dataEdit: null,
			deleteId: 0,
			createErrorMessage: "Gagal Menyimpan Data Bank Baru.",
			errorMessages: [],
			itemToDelete: {},
			rekeningbanks: [],
			searchValue: "",
			loadData: true,
			savingNewRekeningBank: false,
			errorNewRekeningBank: false,
			errorRekeningBankList: [],
			errorClientSaved: false,
			existingClientResult: [],
			newRekeningBankSaved: false,
			updateClientState: false,
			updateClientSaved: false,
			updateUserState: false,
			selectedBank: 0,
			selectedTab: 0,
			updateClientCol: 6,
			newRekeningBank: {
				nama: "",
				nama_bank: "",
				no_rekening: "",
				cabang: ""
			},
			formRekeningBankActive: false,
			rekeningbankTableStructure: [
				//label: nama heading, key: nama object property
				{label: "No", key: null},
				{label: "Nama Pemilik Bank", key: null},
				{label: "Nama Bank", key: null},
				{label: "Nomor Rekening", key: null},
				{label: "Cabang", key: null},
				{label: "Status", key: null},
				{label: "Tindakan", key: null}
			]
		};
	},
	created() {
		console.clear();
		this.$reActivateAccess(this); /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
		console.log("bank page");
		this.getRekeningBanks();
		this.isMobile = this.$isMobile;
		window.addEventListener("resize", () => {
			console.log("screen update");
			this.isMobile = screen.width < 768;
		});
		// var newData = [];
		// for(var x=0;x<100;x++){
		//     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
		// }
		// console.log(newData);
		// this.users = newData;
	},
	methods: {
		changePage(isNext) {
			var url = (isNext ? this.nextUrl : this.prevUrl);
			let params = (new URL(url)).searchParams;
			const myParams = params.get("page");
			this.currentPage = parseInt(myParams);
			var newUrl = this.$baseUrl + "/api/master/bank?limit=" + this.rowLimit + "&page=" + myParams;
			this.getRekeningBanks(newUrl);
		},
		deleteResult(deleted) {
			console.log(deleted);
			if (deleted) {
				this.getRekeningBanks();
			}
		},
		getRekeningBanks(url = (this.$baseUrl + "/api/master/bank?limit=" + this.rowLimit)) {
			this.loadData = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.prevUrl = result.data.prev_page_url;
				this.nextUrl = result.data.next_page_url;
				this.currentPage = result.data.current_page;
				this.perPage = parseInt(result.data.per_page);
				this.rekeningbanks = result.data.data;
				this.loadData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},
		saveNewRekeningBank() {
			this.savingNewRekeningBank = true;
			this.errorNewRekeningBank = false;
			console.log(this.newRekeningBank);
			if (this.newRekeningBank.nama != "" && this.newRekeningBank.nama_bank != "" && this.newRekeningBank.no_rekening && this.newRekeningBank.cabang) {
				axios.post(
					this.$baseUrl + "/api/master/bank",
					{
						nama: this.newRekeningBank.nama,
						nama_bank: this.newRekeningBank.nama_bank,
						no_rekening: this.newRekeningBank.no_rekening,
						cabang: this.newRekeningBank.cabang
					},
					{
						"headers":
							{
								"Authorization": "Bearer " + localStorage.getItem("accessToken")
							}
					}
				).then((result) => {
					//console.log(result)
					if (result.data.create) {
						this.getRekeningBanks();
					}
					this.newRekeningBank.nama = "",
						this.newRekeningBank.nama_bank = "",
						this.newRekeningBank.no_rekening = "",
						this.newRekeningBank.cabang = "",
						this.savingNewRekeningBank = false;
					this.newRekeningBankSaved = true;

					setTimeout(() => {
						this.newRekeningBankSaved = false;
						this.formRekeningBankActive = false;
					}, 1500);

				}).catch((err) => {
					//check if token fail
					if (err.response && err.response.status == 401) {
						localStorage.removeItem("accessToken");
						this.$router.push("/login");
					}
					console.log(err.response);
					this.errorRekeningBankList = [];
					this.errorRekeningBankList = Object.values(err.response.data.errors);
					console.log(this.errorRekeningBankList);
					this.errorNewRekeningBank = true;
					this.savingNewRekeningBank = false;
				});
			} else {
				//pakai ini ary
				this.errorNewRekeningBank = true;
				this.savingNewRekeningBank = false;
				this.errorRekeningBankList = [];
				if (this.newRekeningBank.nama == "") {
					this.errorRekeningBankList.push(["- Mohon isi nama pemilik bank"]);
				}
				if (this.newRekeningBank.no_rekening == "") {
					this.errorRekeningBankList.push(["- Mohon isi nomor rekening"]);
				}
				if (this.newRekeningBank.cabang == "") {
					this.errorRekeningBankList.push(["- Mohon isi nama cabang"]);
				}
				if (this.newRekeningBank.nama_bank == "") {
					this.errorRekeningBankList.push(["- Mohon isi nama bank"]);
				}
				console.log(this.errorRekeningBankList);
			}
		},
		newUsernameChange() {
			this.newRekeningBank.password = this.newRekeningBank.username.toUpperCase();
		},
		deleteItem(item) {
			console.log("button delete untuk user id: " + item.id);
		},
		updateUserRoleValue(newValue) {
			this.newRekeningBank.role = newValue;
		},
		setNewClientId(newId) {
			this.newRekeningBank.clientId = newId;
			console.log(this.newRekeningBank.clientId);
		},

		updateClientData() {
			console.log("updating data");
			this.updateClientState = true;
			axios.put(this.$baseUrl + "/api/master/bank/" + this.rekeningbanks[this.selectedBank].id, {
				nama: this.rekeningbanks[this.selectedBank].nama,
				nama_bank: this.rekeningbanks[this.selectedBank].nama_bank,
				no_rekening: this.rekeningbanks[this.selectedBank].no_rekening,
				cabang: this.rekeningbanks[this.selectedBank].cabang,
				status_bank: this.rekeningbanks[this.selectedBank].status_bank

			}, {
				          "headers": {
					          "Authorization": "Bearer " + localStorage.getItem("accessToken")
				          }
			          }).then((result) => {
				if (result.status == 200) {
					this.updateClientState = false;
					this.updateClientSaved = true;
					//step 4 edit
					this.dataEdit = this.rekeningbanks[this.selectedBank];
					setTimeout(() => {
						this.updateClientSaved = false;
						this.$bvModal.hide("modal-edit-bank");
					}, 1000);
					console.log("yaya berhasil");
				}
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.updateClientState = false;
				this.errorClientSaved = true;
				setTimeout(() => {
					this.errorClientSaved = false;
				}, 1000);
				console.log(err.response);
			});
		},
		editModalClose(mdl) {
			//step 2 edit
			this.$set(this.rekeningbanks, this.selectedBank, this.dataEdit);
			//step 3 edit
			this.dataEdit = Object.assign({}, null);
			if (this.updateUserState || this.updateClientState) {
				console.log("updating");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-edit-bank");
			}
		},
		deleteModalClose(mdl) {
			if (this.deleteUserState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-delete-user");
			}
		},

		deleteClientData() {
			console.log("deleting data");
			this.deleteUserState = true;
			axios.delete(this.$baseUrl + "/api/master/bank/" + this.users[this.selectedToDelete].id, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				if (result.status == 200) {
					this.deleteUserState = false;
					this.userDeleted = true;
					this.users.splice(this.selectedToDelete, 1);

					setTimeout(() => {
						this.$bvModal.hide("modal-delete-user");
						this.userDeleted = false;
					}, 1500);
					console.log("yaya berhasil");
				}
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.deleteUserState = false;
				this.failDeleteUser = true;
				setTimeout(() => {
					this.failDeleteUser = false;
				}, 1500);
				console.log(err);
			});
		}
	}
};
</script>
<style scoped>
.btn {
	padding: 2px 6px;
}

::v-deep .modal-content {
	margin: -3.25rem auto;
}
</style>
